import {
  fetchAuthSession,
  fetchUserAttributes,
  signOut,
} from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { Maybe } from "../utils/types/maybe.ts";

type Authentication = {
  user: Maybe<User>;
  accessToken: Maybe<string>;
  signOut: () => void;
};

type User = {
  attributes: {
    email: Maybe<string>;
    name: Maybe<string>;
  };
};

export function useAuthentication(): Authentication {
  const [currentUser, setCurrentUser] = useState<Maybe<User>>(null);
  const [currentAccessToken, setCurrentAccessToken] =
    useState<Maybe<string>>(null);

  useEffect(() => {
    (async () => {
      const attributes = await fetchUserAttributes();
      setCurrentUser(
        attributes == null
          ? null
          : {
              attributes: {
                email: attributes.email,
                name: attributes.name,
              },
            },
      );

      const { accessToken } = (await fetchAuthSession()).tokens ?? {};
      setCurrentAccessToken(accessToken?.toString());
    })();
  }, []);

  return {
    user: currentUser,
    accessToken: currentAccessToken,
    signOut: () => signOut(),
  };
}
